export default __webpack_public_path__ + "static/media/switch.c57aa04c.svg";